import type { ConnectedPosition } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

import type { OverlayPosition, SizeMenuController } from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';

import { SizeMenuComponent } from './size-menu.component';

@Injectable()
export class SizeMenuService
  extends WysiwygComponentPortalService<SizeMenuComponent>
  implements SizeMenuController
{
  protected overlayConfig = {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
  };

  public open(
    position: OverlayPosition | DOMRect,
    _options: {
      getActiveVal: () => string | null;
      preferredPositions?: ConnectedPosition[];
    },
  ) {
    const options = {
      preferredPositions: _options.preferredPositions || [
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
      ],
    };
    this.close();
    this.openComponent(SizeMenuComponent, position, options.preferredPositions, {
      skipComponentCD: true,
    });
    const { instance, location } = this.componentRef!;
    instance.close = () => {
      this.close();
    };
    instance.getActiveVal = _options.getActiveVal;
    this.componentRef?.changeDetectorRef?.detectChanges();
    return {
      element: <HTMLElement>location.nativeElement,
      backdropClick$: this.overlayRef!.backdropClick(),
    };
  }

  public setSelectCallback(selectCb: (val: string) => void): void {
    if (!this.componentRef) return;
    this.componentRef.instance.select = selectCb;
  }
}
